











import { PluginMixin } from '@spa/mixins/plugin'
import store from '@spa/store'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

export type Color = 'default' | 'black'
export type ReadTopUrl = () => Promise<string>
const useStore: ReadTopUrl = async () => {
  await store.dispatch('history/setUrlToContinueShopping')

  return store.getters['history/topUrl'] || '/'
}

@Component
export default class ToTopPage extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ default: 'default' })
  readonly color: Color

  @Prop({ default: () => useStore })
  readonly readTopUrl: ReadTopUrl

  url: string = '/'

  async created() {
    this.url = await this.readTopUrl()
  }

  get buttonClass(): string[] {
    return [
      'c-btn--w-large',
      'c-btn--h-middle',
      'c-btn--center',
      `c-btn--${this.color}`,
    ]
  }
}
